import React from 'react';
import { Lists, HeaderSwiper } from '@/components/mixins'
import '../../common/common.scss'
import './Robot.scss'
class Robot extends React.PureComponent {
  constructor() {
    super()
    this.state = {
      headerDataLists: [
        { imgPath: require("img/EcosphereDetails/Robotbanner.png"), imgHDPath: `${require("img/EcosphereDetails/Robotbanner.png")} 1x,${require("img/EcosphereDetails/Robotbanner@2x.png")} 2x,${require("img/EcosphereDetails/Robotbanner@3x.png")} 3x`, attachURL: "/" }
      ],
      dataLists01: [
        {
          title: '拟人化',
          data: '不是物理机器人，而是软件程序模拟人对计算机进行操作。',
        },
        {
          title: '高效作业',
          data: '7×24小时无间隙工作，相当于人工3-5倍以上的工作效率。',
        },
        {
          title: '标准化',
          data: '青矩1.0标准化拆分作业体系基础上进行升级再造。',
        },

        {
          title: '规范化',
          data: '按既定的规则执行业务，作业具备自我审核和校验的机制。',
        },
        {
          title: '多线程',
          data: '可灵活的根据业务量进行自由扩充，实现多线程并行作业，效率提升70%以上。',
        },
      ],
      dataLists02: [
        {
          title: '产品介绍',
          data: '第一代产品“小青1号”在人工识图、图纸标准化处理、作业拆分的基础上，通过人工智能自动识别技术，在自动进行清单列项、多线程并行作业、自动建模图形算量等方面均取得重大技术突破。<br>第二代产品“小青1s”借助图像识别、Al人工智能等技术，实现了技术服务全新升级。相比上—代产品，小青1s图纸处理效率、识别准确率进—步提升，并全面接入工程算量专业体系，实现单独钢筋建模到土建、安装全专业建模的蜕变，将智慧造价提升到了全新高度。',
          imgPath: require("img/EcosphereDetails/Roboticon01.png"), imgHDPath: `${require("img/EcosphereDetails/Roboticon01.png")} 1x,${require("img/EcosphereDetails/Roboticon01@2x.png")} 2x,${require("img/EcosphereDetails/Roboticon01@3x.png")} 3x`
        },
        {
          title: '服务理念',
          data: '小青，致力于将工程造价咨询人员从繁重、低效、重复的算量工作中解脱出来，使其将更多精力投向需要更高技术要求和专业判断能力的领域，从而推动工程咨询行业迈入“智慧造价”新时代。',
          imgPath: require("img/EcosphereDetails/Roboticon02.png"), imgHDPath: `${require("img/EcosphereDetails/Roboticon02.png")} 1x,${require("img/EcosphereDetails/Roboticon02@2x.png")} 2x,${require("img/EcosphereDetails/Roboticon02@3x.png")} 3x`
        },
      ],
    }
  }
  render() {
    return (
      <main className="Development-container">
        <HeaderSwiper headerDataLists={this.state.headerDataLists}></HeaderSwiper>
        <div className="Development">
          <h5 className='product-title'>产品优势</h5>
          <Lists dataLists={this.state.dataLists01}></Lists>
          <h5 className='product-title'>服务介绍</h5>
          <Lists dataLists={this.state.dataLists02}></Lists>
        </div>
      </main>
    )
  }
}
export default Robot
